import { Link } from "react-router-dom";
import Breadcrumbs from "@/components/site/Breadcrumbs";
import Seo from "@/components/site/Seo";
import { Img } from "@/assets";

const PRODUCTS = [
  { name: "Crude oil", body: "Traded and distributed to refiners and blending operations." },
  { name: "Diesel and gasoil", body: "Middle-distillate supply for industrial, transport and marine end-uses." },
  { name: "Jet fuel", body: "Aviation-grade kerosene supplied through established international routing." },
  { name: "Gasoline", body: "Motor gasoline supplied to distributors and downstream partners." },
  { name: "Bitumen", body: "Bulk bitumen for infrastructure and roadwork programmes." },
  { name: "Urea", body: "A related chemical commodity — not a fuel — traded alongside our petroleum activities." },
];

export default function PetroleumEnergy() {
  return (
    <>
      <Seo />
      <section className="gp-page-hero" data-testid="petroleum-hero">
        <div className="gp-page-hero__img" aria-hidden="true"><Img id="refinery-dusk-wide" alt="" /></div>
        <div className="gp-wrap gp-page-hero__inner">
          <Breadcrumbs trail={[{ to: "/divisions", label: "Our Divisions" }, { to: "/divisions/petroleum-energy", label: "Petroleum & Energy" }]} />
          <h1 className="gp-h1 gp-page-hero__title" style={{ marginTop: 20 }}>Trading and distribution across petroleum and related commodities.</h1>
          <p className="gp-page-hero__lede">
            The Petroleum &amp; Energy division trades and distributes crude, refined products, gas
            and related commodities. We work with counterparties who value transparent terms and
            consistent execution.
          </p>
        </div>
      </section>

      <section className="gp-section gp-on-white" data-testid="petroleum-products">
        <div className="gp-wrap">
          <div className="gp-eyebrow" style={{ color: "var(--gp-ink)" }}>
            <span className="gp-eyebrow-num">01</span><span className="gp-eyebrow-sep" /> Products
          </div>
          <h2 className="gp-h2" style={{ maxWidth: "22ch", marginBottom: 56 }}>Commodities we trade and distribute.</h2>
          <div className="gp-products">
            {PRODUCTS.map((p, i) => (
              <div className="gp-product" key={p.name} data-testid={`product-${slug(p.name)}`}>
                <div className="gp-product__num">{String(i + 1).padStart(2, "0")} / Product</div>
                <div className="gp-product__name">{p.name}</div>
                <p className="gp-product__body">{p.body}</p>
              </div>
            ))}
          </div>
          <div className="gp-callout">
            <p>This is a corporate information page. For enquiries about supply relationships, please contact us directly.</p>
            <Link to="/contact" className="gp-btn gp-btn--on-white" data-testid="petroleum-cta-contact">Contact us <span className="gp-arrow">→</span></Link>
          </div>
        </div>
      </section>

      <section className="gp-on-navy" style={{ paddingBlock: "clamp(48px, 6vw, 96px)" }}>
        <div className="gp-wrap" style={{ display: "flex", justifyContent: "space-between", gap: 24, flexWrap: "wrap", alignItems: "center" }}>
          <div className="gp-eyebrow" style={{ margin: 0 }}><span className="gp-eyebrow-sep" /> Next</div>
          <Link to="/divisions/precious-metals" className="gp-link" data-testid="petroleum-cta-metals">Precious Metals division <span className="gp-arrow">→</span></Link>
        </div>
      </section>
    </>
  );
}
function slug(s) { return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, ""); }
